export const formatLocalDate = (date: Date, time: string) => {
  // Полуяаем год из объекта даты
  const year = date.getFullYear();
  // Формтируем месяц, добавляя ноль перед числом если меньше 10
  const month = (date.getMonth() + 1 < 10 ? '0' : '') + (date.getMonth() + 1);
  // Форматируем день, добавляя ноль перед числом
  const day = (date.getDate() < 10 ? '0' : '') + date.getDate();
  return `${year}-${month}-${day}${time}`;
};

export const formatLocalDateToUtc = (date: Date, time: string) => {
  const localString = formatLocalDate(date, time);
  const isoString = new Date(localString).toISOString();

  return isoString.split('.')[0];
};
